<template>
    <div class="flex items-center gap-2.5 mb-5">
        <div @click="toggle()">
            <img src="@/assets/icon/ic-checkbox-inactive.svg" alt="" v-show="!modelValue" v-cloak />
            <img src="@/assets/icon/ic-checkbox-active.svg" alt="" v-show="modelValue" v-cloak />
        </div>
        <div class="text-black text-14">
            <slot>{{ label }}</slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        modelValue: {
            type: Boolean
        },
        label: {
            type: String
        },
        lazy:{
            type: Boolean
        }
    },
    emits: ["update:modelValue", "willChange"],
    setup: function (props, ctx) {
        const toggle = function () {
            if(props.lazy == true){
                ctx.emit("willChange", !props.modelValue)
            }else{
                ctx.emit("update:modelValue", !props.modelValue)
            }
        }

        return {
            toggle
        }
    }
}
</script>
